import { useEffect, useState } from "react";

const useReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetch("https://mbababd24.onrender.com/review")
      .then((res) => res.json())
      .then((data) => {
        setReviews(data.reverse());
        setIsLoading(false);
      });
  }, []);
  return [reviews, isLoading];
};

export default useReviews;
